'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DynamicStyleDirective=function(_BaseControllerBacked){_inherits(DynamicStyleDirective,_BaseControllerBacked);function DynamicStyleDirective(){_classCallCheck(this,DynamicStyleDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DynamicStyleDirective,[{key:'restrict',get:function()
{
return'E';
}},{key:'textBindings',get:function()

{
return['cssPath'];
}},{key:'objectBindings',get:function()

{
return['styleDefinition'];
}},{key:'template',get:function()

{
return'<style type="text/css" data-ng-bind="controller.currentRule"></style>';
}},{key:'controller',get:function()

{
return DynamicStyleDirectiveController;
}}]);return DynamicStyleDirective}(BaseControllerBackedDirective);let


DynamicStyleDirectiveController=function(){_createClass(DynamicStyleDirectiveController,null,[{key:'$inject',get:function()
{return['$scope']}}]);

function DynamicStyleDirectiveController($scope){var _this2=this;_classCallCheck(this,DynamicStyleDirectiveController);
this._$scope=$scope;

$scope.$watch('controller.styleDefinition',function(newDef,oldDef){
if(newDef===oldDef){
return;
}

_this2._setNewRule(newDef);
});

this._setNewRule(this.styleDefinition);
}DynamicStyleDirectiveController.prototype.

_setNewRule=function _setNewRule(rule){var _this3=this;
this._$scope.$evalAsync(function(){
if(!rule){
_this3.currentRule=`${_this3.cssPath} { }`;
return;
}

_this3.currentRule=`${_this3.cssPath} { ${rule} }`;
});
};return DynamicStyleDirectiveController}();


module.exports=DynamicStyleDirective;
//# sourceMappingURL=dynamicStyleDirective.js.map
